import { render, staticRenderFns } from "./SampleSwatchesMitrex.vue?vue&type=template&id=4ffb356e&scoped=true"
var script = {}
import style0 from "./SampleSwatchesMitrex.vue?vue&type=style&index=0&id=4ffb356e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffb356e",
  null
  
)

export default component.exports